<script setup>
import { computed } from 'vue'
import CountryManualSortableItem from './CountryManualSortableItem.vue'

const props = defineProps({
  day: {
    type: Object,
    required: true,
  },
  cdnUrl: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  selectedRookieIds: {
    type: [Array, Set],
    default: () => new Set(),
  },
  selectedRookieDay: {
    type: String,
    default: null,
  },
})

defineEmits(['remove', 'select'])

const dayKey = computed(() => String(props.day.day))

function rookieSelectKey(rookie) {
  if (!rookie) {
    return ''
  }
  return String(rookie.id || rookie.image_id || '')
}

function isSelected(rookie) {
  const key = rookieSelectKey(rookie)
  const selected = props.selectedRookieIds
  const hasKey = selected instanceof Set ? selected.has(key) : selected.includes(key)
  return !!key && props.selectedRookieDay === dayKey.value && hasKey
}
</script>

<template>
  <el-card style="margin-top: 5px" shadow="never" :header="`第${day.day}天`" v-loading="loading">
    <div class="cm-drag-list">
      <CountryManualSortableItem
        v-for="(rookie, index) in day.images"
        :key="rookie.id || `${rookie.image_id}-${index}`"
        :rookie="rookie"
        :index="index"
        :group="`day-${day.day}`"
        :cdn-url="cdnUrl"
        :selected="isSelected(rookie)"
        @select="$emit('select', rookie)"
        @remove="$emit('remove', $event)"
      />
    </div>
  </el-card>
</template>

<style scoped>
.cm-drag-list {
  display: flex;
  flex-wrap: wrap;
}
</style>
